export default "__VITE_ASSET__CUDwRf4G__"